import { isDev } from "../../base/index.js";
import { deriveValuesFromState } from "../utils/deriveValuesFromState.js";
function createReducer() {
  return (store, action) => {
    switch (action.type) {
      case "setField": {
        const { key, value } = action;
        const state = {
          ...store.schema,
          [key]: { ...store.schema[key], value }
        };
        const values = deriveValuesFromState(state);
        return { ...store, schema: state, values };
      }
      case "resetFields": {
        const state = store.initialState;
        const values = deriveValuesFromState(state);
        return { ...store, schema: state, values };
      }
      case "updateSchema": {
        const { schema } = action;
        const nextSchema = { ...store.schema };
        for (const [key, field] of Object.entries(schema)) {
          if (field === null) {
            delete nextSchema[key];
          } else {
            const target = nextSchema;
            target[key] = field;
          }
        }
        const values = deriveValuesFromState(nextSchema);
        return { ...store, schema: nextSchema, values };
      }
      default:
        if (isDev()) {
          throw new Error("unhandled action type", action);
        }
        return store;
    }
  };
}
export {
  createReducer
};
//# sourceMappingURL=createReducer.js.map
